<div class="main-div">
  <kp-header></kp-header>
  <div class="content" [style.min-height.px]="outletHeight">
    <div class="outlet-div" role="main">
      <button
        mat-fab
        color="primary"
        aria-labelledby="backButtonLabel"
        *ngIf="showBackButton()"
        (click)="onBackClicked()">
        <mat-icon>keyboard_backspace</mat-icon><span id="backButtonLabel" class="visually-hidden">Back</span>
      </button>
      <router-outlet *ngIf="!isIframe"></router-outlet>
    </div>
  </div>
  <kp-footer></kp-footer>
</div>
